import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-items-center tw-gap-8 tw-relative tw-top-[15%]" }
const _hoisted_2 = {
  "data-test": "no-access-authorization-header",
  class: "tw-text-center headlines--headline-02 tw-text-core-primary-10"
}
const _hoisted_3 = {
  class: "tw-max-h-[80vh] tw-overflow-y-auto",
  "data-test": "no-access-admin-list"
}
const _hoisted_4 = { class: "body--body-01 tw-text-core-primary-10" }

import CoreLink from 'frontcore/views/link/CoreLink.vue'
import i18n from 'frontcore/i18n'
import LogoutCoreButton from 'frontcore/domain/authorization/view/LogoutCoreButton.vue'
import useNotAuthorization from 'frontend/presentation/not-authorization/domain/useNotAuthorization'
import { LoginTypeOptions } from 'frontcore/domain/authorization/model/types'
import { onBeforeMount } from 'vue'
import { useProfileStore } from 'frontcore/store/useProfileStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotAuthorization',
  setup(__props) {

const { t } = i18n.global

const useCase = useNotAuthorization()

const profileStore = useProfileStore()

onBeforeMount(() => {
  useCase.loadAdministrators()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(useCase).accessMessage) + ": ", 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useCase).administrators, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          "data-test": "no-access-admin-item",
          class: "body--body-01 tw-text-core-primary-10"
        }, [
          _createTextVNode(_toDisplayString(item.name) + " ", 1),
          (item.email)
            ? (_openBlock(), _createBlock(CoreLink, {
                key: 0,
                linkText: item.email,
                to: `mailto:${item.email}`,
                dataTest: `admin-email-${item.id}`,
                isExternal: ""
              }, null, 8, ["linkText", "to", "dataTest"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_unref(t)('common.messages.alternative_way_to_contact')) + " ", 1),
      _createVNode(CoreLink, {
        linkText: _unref(t)('common.messages.support'),
        to: _unref(useCase).mailToSupport,
        dataTest: "support-email-link",
        isExternal: ""
      }, null, 8, ["linkText", "to"])
    ]),
    _createVNode(LogoutCoreButton, {
      userLoginType: _unref(profileStore).loginType ?? _unref(LoginTypeOptions).Django,
      onLogoutSuccess: _unref(useCase).logout
    }, null, 8, ["userLoginType", "onLogoutSuccess"])
  ]))
}
}

})